import { useContext, useMemo } from 'react';
import moment from 'moment';
import { DataContext } from '../context/data-context';
import { getCurrentMatches } from '../utils/matches';
import { useApi } from './api';

export const useCurrentMatchesTeam = (abbrv) =>
  useApi(`team/current-matches?id=${abbrv}`);

export const useCurrentMatches = () => {
  const [data, loading, error] = useApi('current-matches');
  const [data2, loading2, error2] = useApi('qualification-matches');

  const matches = useMemo(
    () => (data && data2 ? getCurrentMatches([...data, ...data2], 5, 5) : []),
    [data, data2]
  );

  return [matches, loading || loading2, error || error2];
};

export const useMatchesMinimized = (season) =>
  useApi(`match-list/minimized?season=${season}`);

export const useMatches = () => useApi('team/match-list');

function getMathDate() {
  // Debug dates with a query parameter
  const dateParam = new URLSearchParams(window.location.search).get(
    'matchDate'
  );

  // Show matches from yesterday if it's before 3 AM and today if its after 5 AM
  let matchDate = moment(dateParam || undefined);
  if (matchDate.hour() < 3) {
    matchDate.subtract(1, 'day');
  } else if (matchDate.hour() < 5) {
    matchDate = null;
  }

  return matchDate;
}

function withFakeStatus(match) {
  const dateParam = new URLSearchParams(window.location.search).get(
    'matchDate'
  );

  if (dateParam) {
    const status =
      moment(match.startDate).isBefore(dateParam) &&
      moment(match.startDate).add(90, 'minutes').isAfter(dateParam)
        ? 'ONGOING'
        : match.status;
    return {
      ...match,
      status,
      matchMinuteWithStoppageTime:
        status === 'ONGOING'
          ? moment(dateParam).diff(match.startDate, 'minutes').toString()
          : match.matchMinuteWithStoppageTime,
    };
  }

  return match;
}

export const useMatchesToday = () => {
  const { currentSeason } = useContext(DataContext);
  const [matches, loading, error] = useMatchesMinimized(currentSeason);

  const matchDate = getMathDate();

  const matchesToday = useMemo(() => {
    if (!matchDate) return [];

    return matches
      ?.filter((match) => moment(match.startDate).isSame(matchDate, 'day'))
      .map(withFakeStatus);
  }, [matches, matchDate?.hour()]);

  return [matchesToday, loading, error];
};

export const useLatestHighlights = () => {
  const { league, currentSeason } = useContext(DataContext);
  const [data, loading, error] = useApi(
    `latest-highlights?league=${league}&season=${currentSeason}`
  );

  const matchDate = getMathDate();

  const highlights = useMemo(
    () =>
      data?.some(
        (h) => matchDate && moment(h.video.date).isSame(matchDate, 'day')
      )
        ? data
        : null,
    [data, matchDate.hour()]
  );

  return [highlights, loading, error];
};
